var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, observable, makeObservable } from 'mobx';
export class WordTaskEvaluate {
    parent;
    manifestedEvaluationValue = '';
    manifestedMatchSimilarity = 0;
    manifestedDisproveCertainty = 0;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get wordTask() {
        return this.parent;
    }
    get matchSimilarity() {
        if (this.manifestedMatchSimilarity) {
            return this.manifestedMatchSimilarity;
        }
        if (!this.wordTask.wordTaskNearest.nearestWording)
            return 0;
        return this.wordTask.wordTaskNearest.nearestWording.wordingEvaluator.reachedSimilarity;
    }
    get disproveCertainty() {
        if (this.manifestedDisproveCertainty) {
            return this.manifestedDisproveCertainty;
        }
        if (!this.wordTask.wordTaskNearest.weakestDisprove)
            return 0;
        return this.wordTask.wordTaskNearest.weakestDisprove.wordingEvaluator.disproveCertainty;
    }
    get evalStatus() {
        if (this.wordTask.wordTaskInfo.onlyEvaluateOnManualSend && !this.wordTask.taskProgress.isTaskCompleted) {
            if (!this.wordTask.wordTaskInfo.isCurrentlyHittingEnter)
                return undefined;
        }
        if (this.matchSimilarity >= this.wordTask.requiredAccuracy)
            return true;
        if (this.disproveCertainty > 100 - this.wordTask.requiredAccuracy)
            return false;
        return undefined;
    }
    get isCorrectToCurrentInput() {
        return this.evalStatus === true;
    }
    get isWrongToCurrentInput() {
        return this.evalStatus === false;
    }
    get isMainifestedCorrect() {
        return this.wordTask.taskProgress.isTaskCompleted && this.isCorrectToCurrentInput;
    }
    get isMainifestedWrong() {
        return this.wordTask.taskProgress.isTaskCompleted && this.isWrongToCurrentInput;
    }
}
__decorate([
    observable
], WordTaskEvaluate.prototype, "manifestedEvaluationValue", void 0);
__decorate([
    observable
], WordTaskEvaluate.prototype, "manifestedMatchSimilarity", void 0);
__decorate([
    observable
], WordTaskEvaluate.prototype, "manifestedDisproveCertainty", void 0);
__decorate([
    computed
], WordTaskEvaluate.prototype, "matchSimilarity", null);
__decorate([
    computed
], WordTaskEvaluate.prototype, "disproveCertainty", null);
__decorate([
    computed
], WordTaskEvaluate.prototype, "evalStatus", null);
